export default function WhatIsSection() {
  return (
    <section className="py-14 md:py-20 bg-accent-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <span className="inline-block px-4 py-1.5 bg-background-50 rounded-full text-xs md:text-sm font-medium text-accent-700 mb-4 md:mb-6">
            CSSBuy Sheet SEO Hub
          </span>

          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-6 md:mb-8">
            What Is a CSSBuy Spreadsheet?
          </h2>

          <div className="prose prose-sm md:prose-base max-w-none text-foreground-700 space-y-4">
            <p className="leading-relaxed">
              A <strong className="text-foreground-950">CSSBuy spreadsheet</strong> is a curated product discovery system designed for agent shopping enthusiasts. Unlike traditional browsing where you scroll endlessly through product listings, a well-organized spreadsheet compiles the best finds across multiple categories — from sneakers and streetwear to luxury accessories and budget-friendly basics — into one easily navigable collection.
            </p>
            <p className="leading-relaxed">
              These spreadsheets have become the backbone of the agent shopping community because they solve a real problem: <strong className="text-foreground-950">finding quality items quickly</strong>. Instead of spending hours searching through Chinese marketplaces and agent platforms, users rely on curated spreadsheet lists that have already been vetted for quality, style, and value. The <strong className="text-foreground-950">CSSBuy spreadsheet</strong> in particular has gained massive popularity for its comprehensive coverage and regular weekly updates.
            </p>
            <p className="leading-relaxed">
              Beyond CSSBuy, the spreadsheet ecosystem has expanded to include dedicated lists for other major agent platforms like <strong className="text-foreground-950">Kakobuy</strong>, <strong className="text-foreground-950">Superbuy</strong>, and <strong className="text-foreground-950">Oopbuy</strong>. Each platform offers distinct advantages — some excel at fast fashion finds, others focus on verified premium items, and budget-conscious shoppers have their own dedicated channels. This multi-agent approach ensures that no matter your shopping style or budget, there is a curated spreadsheet ready to help you discover your next favorite piece.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-10 md:mt-12">
            {[
              { value: '1000+', label: 'Items Indexed' },
              { value: '14', label: 'Categories' },
              { value: '4', label: 'Agent Platforms' },
              { value: 'Weekly', label: 'Fresh Updates' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="font-heading text-2xl md:text-3xl font-bold text-accent-600">{stat.value}</p>
                <p className="text-xs md:text-sm text-foreground-600 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}